import alterpressApi from './base';

import {
    ICreateOrderMutation,
    ICreateOrderResponse,
    IGetOrderPaymentStatusResponse,
    IGetOrderStatusResponse,
    IOrder,
    IUserOrder,
    IOrderDraft,
    ISendPayUTokenMutation,
    ISendPayUTokenResponse,
    IValidateOrderMutation,
} from '../../models/order.model';
import { IDelivery } from '../../models/delivery.model';
import { IPaymentProvider } from '../../models/payment-provider.model';

export const orderApi = alterpressApi
    .enhanceEndpoints({
        addTagTypes: ['Order'],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getOrders: builder.query<IOrder[], void>({
                query: () => 'account/orders?expand=orderStatus,items,addresses,payments,delivery',
                providesTags: ['Order'],
            }),
            getOrder: builder.query<IUserOrder, string | undefined | null>({
                query: (uuid) =>
                    `orders/${uuid}?expand=media,orderStatus,items,items.product,items.product.media,items.variant,items.variant.media,items.variant,addresses,payments,delivery,items.variant.sets`,
                providesTags: ['Order'],
            }),
            createOrder: builder.mutation<ICreateOrderResponse, ICreateOrderMutation>({
                query: (data) => ({
                    url: `orders?expand=payments`,
                    method: 'POST',
                    body: data,
                }),
                invalidatesTags: ['Order'],
            }),
            validateOrder: builder.mutation<IOrderDraft, IValidateOrderMutation>({
                query: (data) => ({
                    url: `orders/validate`,
                    method: 'POST',
                    body: data,
                }),
                invalidatesTags: ['Order'],
            }),
            getOrderDeliveryProviders: builder.query<
                IDelivery[],
                Pick<IValidateOrderMutation, 'items' | 'discountCodes'>
            >({
                query: (data) => ({
                    url: `orders/available-shipments`,
                    method: 'POST',
                    body: data,
                }),
            }),
            getOrderPaymentProviders: builder.query<
                IPaymentProvider[],
                { items: IValidateOrderMutation['items'] }
            >({
                query: (data) => ({
                    url: `orders/available-payments?expand=media`,
                    method: 'POST',
                    body: data,
                }),
            }),
            retryPayment: builder.mutation<any, string>({
                query: (paymentId) => ({
                    url: `orders/payments/${paymentId}/retry`,
                    method: 'GET',
                }),
            }),
            sendPayUToken: builder.mutation<ISendPayUTokenResponse, ISendPayUTokenMutation>({
                query: (data) => ({
                    url: `payments/payu-tok`,
                    method: 'POST',
                    body: data,
                }),
            }),
            getOrderPaymentStatus: builder.query<
                IGetOrderPaymentStatusResponse,
                string | number | undefined | null
            >({
                query: (paymentId) => `orders/payments/${paymentId}/status`,
            }),
            getOrderStatus: builder.query<IGetOrderStatusResponse, string | undefined | null>({
                query: (orderUid) => `orders/${orderUid}/status`,
            }),
        }),
    });

export const {
    useGetOrderQuery,
    useGetOrdersQuery,
    useCreateOrderMutation,
    useValidateOrderMutation,
    useGetOrderDeliveryProvidersQuery,
    useGetOrderPaymentProvidersQuery,
    useRetryPaymentMutation,
    useSendPayUTokenMutation,
    useGetOrderPaymentStatusQuery,
    useGetOrderStatusQuery,
} = orderApi;
